{
  "familyId": "SWW-LEEN-ENG-KOF",
  "questions": [
    {
      "id": "SWW-LEEN-ENG-KOF-001",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "multiple_choice",
      "question": "Wat is de verleden tijd van 'racen'?",
      "context": null,
      "options": ["racete", "racede", "racte", "raasde"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "racen", "stem": "race", "lastLetter": "e", "useTE": true, "label": "Engelse Leenwoorden + Kofschip" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "Bij Engelse leenwoorden pas je 't kofschip toe op de KLANK. 'Race' klinkt als 'reis' (s-klank), en s zit in kofschip → -te.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_kofschip_race",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: kofschip bij Engelse leenwoorden — kijk naar de KLANK. Stap 1: De stam van 'racen' is 'race'. Stap 2: 'Race' klinkt als 'reis' (s-klank aan het eind). Stap 3: De s-klank zit WEL in 't kofschip → dus -te. Stap 4: race + te = racete. Checkstrategie: bij Engelse leenwoorden altijd naar de KLANK luisteren, niet naar de letter. 'Race' eindigt op -e (letter), maar klinkt als -s (klank).",
        "distractorExplanations": {
          "0": "Correct! Kofschip op klank: 'race' klinkt als s-klank (in kofschip) → race + te = racete.",
          "1": "Veelgemaakte fout: naar de letter kijken in plaats van de klank. 'Racede' gebruikt -de, maar de KLANK van 'race' is een s-klank (in kofschip). Dus -te: racete. Misconceptie: de letter 'e' beoordelen in plaats van de klank.",
          "2": "Veelgemaakte fout: de Engelse spelling aanpassen. 'Racte' mist de -e van 'race'. De Engelse spelling blijft behouden: race + te = racete. Misconceptie: letters weglaten bij het vervoegen.",
          "3": "Veelgemaakte fout: de spelling 'vernederlandsen'. 'Raasde' verandert de spelling van 'race' naar 'raas'. De Engelse spelling blijft behouden: race + te = racete."
        }
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-002",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "multiple_choice",
      "question": "Vul in: Gisteren ... ik het bestand naar de cloud. (uploaden)",
      "context": null,
      "options": ["uploadde", "uploadte", "uploade", "upgeload"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "uploaden", "stem": "upload", "lastLetter": "d", "useTE": false, "label": "Engelse Leenwoorden + Kofschip" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "De stam 'upload' eindigt op 'd'. Deze letter staat NIET in 't kofschip, dus: upload + de = uploadde.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_kofschip_upload",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Regel: kofschip bij Engelse leenwoorden. Stap 1: De stam van 'uploaden' is 'upload'. Stap 2: De laatste letter is 'd'. Stap 3: 'd' staat NIET in 't kofschip → dus -de. Stap 4: upload + de = uploadde. Checkstrategie: bij Engelse leenwoorden dezelfde kofschip-regel toepassen. Kijk naar de laatste letter/klank van de stam.",
        "distractorExplanations": {
          "0": "Correct! Kofschip: 'd' niet in kofschip → upload + de = uploadde.",
          "1": "Veelgemaakte fout: -te gebruiken bij een stam die op d eindigt. 'Uploadte' gebruikt -te, maar 'd' staat NIET in 't kofschip. Dus -de: uploadde. Misconceptie: d verwarren met t in kofschip.",
          "2": "Veelgemaakte fout: de verleden tijd verkeerd vormen. 'Uploade' mist de d van de stam. De stam is 'upload' (met d), dus: upload + de = uploadde.",
          "3": "Veelgemaakte fout: voltooid deelwoord gebruiken zonder hulpwerkwoord. 'Upgeload' is een poging tot voltooid deelwoord. Hier is geen hulpwerkwoord, dus gewoon verleden tijd: uploadde."
        }
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-003",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "multiple_choice",
      "question": "Welke zin is juist?",
      "context": null,
      "options": ["We downloadden de app gisteren.", "We downloadten de app gisteren.", "We downloaden de app gisteren.", "We gedownload de app gisteren."],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "downloaden", "stem": "download", "lastLetter": "d", "useTE": false, "label": "Engelse Leenwoorden + Kofschip" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "De stam 'download' eindigt op 'd' (niet in kofschip), dus meervoud verleden tijd: download + den = downloadden.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_kofschip_download",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Regel: kofschip bij Engelse leenwoorden (meervoud). Stap 1: De stam van 'downloaden' is 'download'. Stap 2: De laatste letter is 'd'. Stap 3: 'd' staat NIET in 't kofschip → dus -de(n). Stap 4: 'We' is meervoud: download + den = downloadden. Checkstrategie: kijk naar de laatste letter van de stam voor kofschip, dan kies je -de (enkelvoud) of -den (meervoud).",
        "distractorExplanations": {
          "0": "Correct! Kofschip: 'd' niet in kofschip → download + den = downloadden (meervoud).",
          "1": "Veelgemaakte fout: -ten gebruiken bij een stam die op d eindigt. 'Downloadten' gebruikt -ten, maar 'd' staat NIET in 't kofschip. Dus -den: downloadden. Misconceptie: d verwarren met t in kofschip.",
          "2": "Veelgemaakte fout: tegenwoordige tijd gebruiken in een verleden-tijdcontext. 'Downloaden' is de tegenwoordige tijd. Het signaalwoord 'gisteren' vraagt om verleden tijd: downloadden.",
          "3": "Veelgemaakte fout: voltooid deelwoord gebruiken zonder hulpwerkwoord. 'Gedownload' is het voltooid deelwoord (hoort bij 'hebben gedownload'). Hier is geen hulpwerkwoord, dus gewoon verleden tijd: downloadden."
        }
      }
    }
  ]
}